package com.bikompanion.ui.strings

val ArBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "إعادة المحاولة"
    override val actionClose = "إغلاق"
    override val actionSubmit = "إرسال"
    override val detailsLabel = "التفاصيل"
    override val detailsShow = "عرض التفاصيل"
    override val detailsHide = "إخفاء التفاصيل"
    override val actionGetDirections = "الحصول على الاتجاهات"
    override val actionShareStation = "مشاركة المحطة"
    override val linkCopied = "تم نسخ الرابط"
    override val locateShow = "إظهار موقعي"
    override val locateFollowHeading = "تتبّع اتجاهي"
    override val locateStopFollowing = "إيقاف تتبّعي"
    override val settingsTitle = "الإعدادات"
    override val actionBack = "رجوع"
    override val settingsAppearance = "المظهر"
    override val settingsLanguage = "اللغة"
    override val languageSystem = "الإعداد الافتراضي للنظام"
    override val themeSystem = "النظام"
    override val themeLight = "فاتح"
    override val themeDark = "داكن"
    override val settingsNotifications = "الإشعارات"
    override val stationAlerts = "تنبيهات المحطات"
    override val notificationsOn = "مفعّلة: سنخبرك عندما تتوفر دراجة في محطة تتابعها"
    override val notificationsOff = "متوقفة: لا يمكن للمحطات التي تتابعها تنبيهك"
    override val notificationsBlocked = "محظورة: اسمح بالإشعارات من إعدادات الموقع في متصفحك"
    override val actionManage = "إدارة"
    override val actionTurnOn = "تفعيل"
    override val settingsSupport = "الدعم"
    override val sendFeedback = "إرسال ملاحظات"
    override val sendFeedbackDescription = "أخبرنا عن مشكلة أو بيانات محطة غير صحيحة"
    override val shareApp = "مشاركة التطبيق"
    override val settingsAbout = "حول"
    override val aboutApp = "حول Bikompanion"
    override val aboutDevelopedBy = "تطوير Tiago Araujo"
    override val aboutDataSources = "مصادر البيانات"
    override val sourceCityBikesDescription = "شبكات مشاركة الدراجات حول العالم"
    override val sourceGbfsTitle = "موجزات GBFS من المشغّلين"
    override val sourceGbfsDescription = "بيانات المحطات المباشرة من مشغّلي مشاركة الدراجات"
    override val sourceOsmTitle = "المساهمون في OpenStreetMap"
    override val sourceOsmDescription = "مواقف الدراجات وبيانات الخريطة"
    override val sourceCartoDescription = "مربعات الخريطة"
    override val aboutLegal = "قانوني"
    override val licensesTitle = "تراخيص المصادر المفتوحة"
    override val privacyPolicy = "سياسة الخصوصية"
    override val deleteRatings = "حذف تقييماتي"
    override val deleteRatingsDescription = "يرسل إلينا معرّفك المجهول بالبريد الإلكتروني لنحذفها"
    override val licensesLoadFailed = "تعذّر تحميل قائمة التراخيص"
    override val aboutVersion = { version: String -> "الإصدار $version" }
    override val issueFlatTire = "إطار مثقوب"
    override val issueFrontBrake = "الفرامل الأمامية لا تعمل"
    override val issueRearBrake = "الفرامل الخلفية لا تعمل"
    override val issueChain = "السلسلة تنزلق"
    override val issueGears = "التروس لا تتبدّل"
    override val issueSeat = "المقعد تالف أو مفقود"
    override val issueLights = "الأضواء لا تعمل"
    override val issueLockOrBasket = "القفل أو السلة تالفة"
    override val issueFrame = "هيكل الدراجة تالف"
    override val issueMotor = "المحرك الكهربائي لا يعمل"
    override val issueBattery = "البطارية لا تشحن"
    override val issueOther = "أخرى"
    override val networksLoadFailed = "تعذّر تحميل شبكات الدراجات. تحقق من اتصالك."
    override val parkingLoadFailed = "تعذّر تحميل مواقف الدراجات"
    override val parkingLoading = "جارٍ البحث عن مواقف الدراجات…"
    override val stationsLoading = "جارٍ تحميل محطات الدراجات…"
    override val noNetworkHereTitle = "لا توجد دراجات مشتركة هنا"
    override val noNetworkHereHint = "صغّر الخريطة للعثور على أقرب شبكة"
    override val installTitle = "ثبّت Bikompanion"
    override val installHintIos = "اضغط على مشاركة، ثم اختر إضافة إلى الشاشة الرئيسية."
    override val installHintAndroid = "احصل على التطبيق من Google Play."
    override val actionInstall = "تثبيت"
    override val parkingTypeStands = "حوامل دراجات"
    override val parkingTypeShed = "مظلة دراجات"
    override val parkingTypeLockers = "خزائن دراجات"
    override val parkingTypeBuilding = "مبنى دراجات"
    override val parkingTypeOther = "موقف دراجات"
    override val fieldAddress = "العنوان"
    override val fieldCovered = "مسقوف"
    override val fieldYes = "نعم"
    override val fieldNo = "لا"
    override val fieldId = "المعرّف"
    override val fieldStationId = "معرّف المحطة"
    override val fieldCoordinates = "الإحداثيات"
    override val fieldCapacity = "السعة"
    override val fieldNetwork = "الشبكة"
    override val fieldName = "الاسم"
    override val fieldCity = "المدينة"
    override val fieldCountry = "البلد"
    override val fieldCompany = "الشركة"
    override val fieldLicense = "الترخيص"
    override val fieldLicenseUrl = "رابط الترخيص"
    override val availabilityBikes = "دراجات"
    override val availabilityElectric = "كهربائية"
    override val availabilityEmpty = "فارغة"
    override val bicingNextPickup = { p0: String -> "الاستلام التالي من Bicing خلال $p0" }
    override val rateTitle = "افحص دراجة أو قيّمها"
    override val rateFindingNetworks = "جارٍ البحث عن شبكات الدراجات حولك…"
    override val rateWhatsWrong = "ما المشكلة فيها؟"
    override val rateBikeNumber = "رقم الدراجة"
    override val rateElectricBike = "دراجة كهربائية"
    override val rateVoteBad = "سيئة"
    override val rateVoteGood = "جيدة"
    override val rateWhichNetwork = "من أي شبكة هذه الدراجة؟"
    override val refreshRateLimited = "تم بلوغ حد الطلبات — تتم إعادة المحاولة تلقائيًا"
    override val refreshFailed = "تعذّر التحديث"
    override val refreshNextUpdate = { p0: Int -> "التحديث التالي خلال $p0 ث" }
    override val refreshUpdating = "جارٍ التحديث…"
    override val dataNone = "لا توجد بيانات بعد"
    override val dataAgeJustNow = "عرض بيانات حديثة جدًا"
    override val dataAgeMinutes = { p0: Int -> "عرض بيانات منذ $p0 د" }
    override val dataAgeHours = { p0: Int -> "عرض بيانات منذ $p0 س" }
    override val dataAgeDays = { p0: Int -> "عرض بيانات منذ $p0 ي" }
    override val actionOpenOperator = { p0: String -> "فتح $p0" }
    override val watchNormal = "مراقبة الدراجات العادية"
    override val watchElectric = "مراقبة الدراجات الكهربائية"
    override val watchInstallNormal = "ثبّت التطبيق لمراقبة الدراجات العادية"
    override val watchInstallElectric = "ثبّت التطبيق لمراقبة الدراجات الكهربائية"
    override val watchStopNormal = "إيقاف مراقبة الدراجات العادية"
    override val watchStopElectric = "إيقاف مراقبة الدراجات الكهربائية"
    override val actionCheckRateBike = "فحص / تقييم دراجة"
    override val layerStations = "المحطات"
    override val layerParking = "مواقف الدراجات"
    override val mapLabelBikes = { p0: Int -> "$p0 دراجة" }
    override val mapLabelEbikes = { p0: Int -> "$p0 كهربائية" }
    override val mapLabelFree = { p0: Int -> "$p0 فارغة" }
    override val scoreHeadline = { p0: String, p1: String -> "الدراجة $p0 · $p1" }
    override val scoreNoRatings = "لا توجد تقييمات بعد — يمكنك إضافة أول تقييم."
    override val scoreLooksGood = "تبدو جيدة."
    override val scoreHasProblems = "واجه الراكبون مشاكل مع هذه الدراجة."
    override val scoreMixed = "آراء متباينة."
    override val ratingNetworkRequired = "اختر أولًا الشبكة التي تتبعها هذه الدراجة."
    override val ratingThanks = { p0: String -> "شكرًا لتقييم الدراجة $p0!" }
    override val ratingCooldown = { p0: Int -> "لقد قيّمت هذه الدراجة مؤخرًا. حاول مجددًا خلال $p0 د." }
    override val ratingQueued = "تم الحفظ — سنرسله عند عودتك إلى الاتصال."
    override val ratingInvalidBike = "رقم الدراجة هذا غير صالح لهذه الشبكة."
    override val ratingRejected = "تعذّر حفظ هذا التقييم. يُرجى المحاولة لاحقًا."
    override val notificationFoundTitle = "دراجة متاحة"
    override val notificationFoundNormal = { p0: String -> "دراجة عادية متاحة في $p0" }
    override val notificationFoundElectric = { p0: String -> "دراجة كهربائية متاحة في $p0" }
    override val notificationExpiredTitle = "انتهت مراقبة المحطة"
    override val notificationExpiredNormal = { p0: String -> "توقفت مراقبة الدراجات العادية في $p0 بعد 30 دقيقة" }
    override val notificationExpiredElectric = { p0: String -> "توقفت مراقبة الدراجات الكهربائية في $p0 بعد 30 دقيقة" }
    override val channelWatchAlertsName = "تنبيهات مراقبة المحطات"
    override val channelWatchAlertsDescription = "توفر الدراجات وتحديثات مراقبة المحطات"
    override val channelBackgroundWatchName = "مراقبة المحطات في الخلفية"
    override val notificationWatchingTitle = "جارٍ مراقبة محطات الدراجات"
    override val notificationWatchingText = "جارٍ مراقبة المحطات المختارة في الخلفية"
    override val scoreFewRatings = { count: Int ->
        arabicPlural(
            count,
            "لا توجد تقييمات حتى الآن.",
            "تقييم واحد فقط حتى الآن.",
            "تقييمان فقط حتى الآن.",
            "$count تقييمات فقط حتى الآن.",
            "$count تقييمًا فقط حتى الآن.",
            "$count تقييم فقط حتى الآن.",
        )
    }
    override val scorePositiveRides = { percent: Int, count: Int ->
        arabicPlural(
            count,
            "$percent% إيجابي في آخر $count رحلة",
            "$percent% إيجابي في آخر رحلة",
            "$percent% إيجابي في آخر رحلتين",
            "$percent% إيجابي في آخر $count رحلات",
            "$percent% إيجابي في آخر $count رحلة",
            "$percent% إيجابي في آخر $count رحلة",
        )
    }
}
